var $a61affdeea006631$exports = {};
$a61affdeea006631$exports = {
    "maximum": `\u{5DE}\u{5E7}\u{5E1}\u{5D9}\u{5DE}\u{5D5}\u{5DD}`,
    "minimum": `\u{5DE}\u{5D9}\u{5E0}\u{5D9}\u{5DE}\u{5D5}\u{5DD}`
};


export {$a61affdeea006631$exports as default};
//# sourceMappingURL=he-IL.mjs.map
